
import Team from './components/team/Team';
import './App.css';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import ProtectedRoute from './components/protectedRoute/ProtectedRoute';
import Login from './components/login/Login';
import Dashboard from './components/dashboard/Dashboard';
import Sidebar from './components/sideBar/sidebar';
import AddTeam from './components/team/AddTeam';
import EditTeam from './components/team/EditTeam';
import AddProject from './components/projects/AddProject';
import Projects from './components/projects/Projects';
import UpdateProject from './components/projects/UpdateProject';
import PositionManager from './components/position/Position';
import ConnectUs from './components/connect_us/ConnectUs';
import EditConnectUs from './components/connect_us/EditConnectUs';
import GetInTouchList from './components/getintouch/GetInTouch';
import Portfolio from './components/category/Category';
import AddPortfolio from './components/category/AddCategory';
import EditPortfolio from './components/category/EditCategory';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        
        <Routes>
          <Route path='/' exact element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute><Sidebar/>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path='/team' exact element={<ProtectedRoute><Sidebar/><Team /></ProtectedRoute>} />
          <Route path='/add_team' exact element={<ProtectedRoute><Sidebar/><AddTeam /></ProtectedRoute>} />
          <Route path='/edit_team/:id' exact element={<ProtectedRoute><Sidebar/><EditTeam /></ProtectedRoute>} />
          <Route path='/projects' exact element={<ProtectedRoute><Sidebar/><Projects /></ProtectedRoute>} />
          <Route path='/add_project' exact element={<ProtectedRoute><Sidebar/><AddProject /></ProtectedRoute>} />
          <Route path='/edit_project/:id' exact element={<ProtectedRoute><Sidebar/><UpdateProject /></ProtectedRoute>} />
          <Route path='/position' exact element={<ProtectedRoute><Sidebar/><PositionManager /></ProtectedRoute>} />
          <Route path='/connectus' exact element={<ProtectedRoute><Sidebar/><ConnectUs /></ProtectedRoute>} />
          <Route path='/edit_connectus/:id' exact element={<ProtectedRoute><Sidebar/><EditConnectUs /></ProtectedRoute>} />
          <Route path='/get_in_touch' exact element={<ProtectedRoute><Sidebar/><GetInTouchList /></ProtectedRoute>} />
          <Route path='/portfolio' exact element={<ProtectedRoute><Sidebar/><Portfolio /></ProtectedRoute>} />
          <Route path='/add_portfolio' exact element={<ProtectedRoute><Sidebar/><AddPortfolio /></ProtectedRoute>} />
          <Route path='/edit_portfolio/:id' exact element={<ProtectedRoute><Sidebar/><EditPortfolio /></ProtectedRoute>} />


        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
